"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.uploadBotGlossaryFile = exports.getBotGlossaryFile = void 0;
var constants_1 = __importDefault(require("@src/constants"));
var utils_1 = require("./utils");
/**
 * Initiates download of current bot glossary for the specific partner
 * @param domainId id of the domain/bot
 */
exports.getBotGlossaryFile = function (domainId) {
    var url = constants_1["default"].ENDPOINTS.BOT_GLOSSARY.GET.GLOSSARY.replace(':domainId', "" + domainId);
    return utils_1.mogamboRequestV3(url, 'GET');
};
/**
 * Initiates upload of bot glossary via a .csv file for the specific partner
 * @param domainId id of the domain/bot
 * @param data .csv file data containing glossary to upload
 */
exports.uploadBotGlossaryFile = function (domainId, data) {
    var url = constants_1["default"].ENDPOINTS.BOT_GLOSSARY.POST.GLOSSARY.replace(':domainId', "" + domainId);
    return utils_1.mogamboRequestV3(url, 'POST', data);
};
